<template>
  <div class="page flex noselect">
    <div class="lfet">
      <div class="title">最近施肥</div>
      <div class="flex">
        <div class="">
          <div class="flex justb alit dlj">
            <div class="flex">
              <img
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%96%BD%E8%82%A5%E5%88%86%E6%9E%90/%E6%B0%AE%402x.png"
                alt=""
              />
              <div class="">
                <div class="text1">氮</div>
                <div class="text2">12</div>
              </div>
            </div>
            <div class="bili">:</div>
            <div class="flex">
              <img
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%96%BD%E8%82%A5%E5%88%86%E6%9E%90/%E7%A3%B7%402x.png"
                alt=""
              />
              <div class="">
                <div class="text1">磷</div>
                <div class="text2" style="color: #ffd725">1</div>
              </div>
            </div>
            <div class="bili">:</div>
            <div class="flex">
              <img
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%96%BD%E8%82%A5%E5%88%86%E6%9E%90/%E9%92%BE%402x.png"
                alt=""
              />
              <div class="">
                <div class="text1">钾</div>
                <div class="text2" style="color: #22dc66">9</div>
              </div>
            </div>
          </div>
          <!-- <div class="ybp flex justb">
            <div class="flexCol alit">
              <ybp1Vue class="ybpecharts"></ybp1Vue>
              <div class="">瞬时流量</div>
            </div>
            <div class="flexCol alit">
              <ybp2Vue class="ybpecharts"></ybp2Vue>
              <div class="">累计流量</div>
            </div>
            <div class="flexCol alit">
              <ybp3Vue class="ybpecharts"></ybp3Vue>
              <div class="">施肥流量</div>
            </div>
          </div> -->

          <div class="flex justb eps">
            <div class="flex alit">
              <img
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%96%BD%E8%82%A5%E5%88%86%E6%9E%90/ec%402x.png"
                alt=""
              />
              <div class="">
                <div class="text3">EC值</div>
                <div class="text4">2.1</div>
              </div>
            </div>
            <div class="flex alit">
              <img
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%96%BD%E8%82%A5%E5%88%86%E6%9E%90/ph%402x.png"
                alt=""
              />
              <div class="">
                <div class="text3">PH值</div>
                <div class="text4">6.5</div>
              </div>
            </div>
            <div class="flex alit">
              <img
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%96%BD%E8%82%A5%E5%88%86%E6%9E%90/%E6%B0%B4%E6%B8%A9%402x.png"
                alt=""
              />
              <div class="">
                <div class="text3">水温</div>
                <div class="text4">23℃</div>
              </div>
            </div>
          </div>
          <div class="flexCol alit fertiliTable">
            <el-table
              style="background-color: transparent; width: 30vw"
              ref="singleTable"
              class=""
              :data="leftTopTableData"
              :header-row-class-name="headerstyle"
              :row-class-name="rowTopStyle"
              @selection-change="handleSelectionChange"
            >
              <el-table-column prop="title" label="" align="center" width="90">
              </el-table-column>
              <el-table-column
                prop="nitrogen"
                label="氮"
                align="center"
				width="55"
              >
              </el-table-column>
              <el-table-column
                prop="phosphorus"
                label="磷"
                align="center"
				width="55"
              >
              </el-table-column>
              <el-table-column
                prop="potassium"
                label="钾"
                align="center"
				width="55"
              >
              </el-table-column>
              <el-table-column prop="startTime" label="开始时间" align="center" >
              </el-table-column>
              <el-table-column prop="endTime" label="结束时间" align="center" >
              </el-table-column>
            </el-table>
          </div>

          <!-- <div class="" style="margin-top: 5px">
            <div class="czlog flex alit">
              <img
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%96%BD%E8%82%A5%E5%88%86%E6%9E%90/%E6%97%A5%E5%BF%97%402x.png"
                alt=""
              />
              <el-carousel
                height="20px"
                style="flex: 1"
                direction="vertical"
                autoplay
                indicator-position="none"
                :interval="6000"
              >
                <el-carousel-item
                  v-for="(item, index) in messageList"
                  :key="item"
                >
                  <div class="flex alit">
                    <div class="" v-if="index < 3">{{ getNowData() }}</div>
                    <div class="" v-else>{{ getYestodayData() }}</div>
                    <div class="medium">{{ item }}</div>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div> -->
        </div>
        <div class="" style="margin-left: 15px; flex: 1">
          <div class="flex justb">
            <div class=""></div>
            <div class="dropcheck">
              <el-dropdown @command="dropcommand">
                <el-button class="check-button">
                  默认 <i class="el-icon-caret-bottom"></i>
                  <!-- <i class="el-icon-arrow-down el-icon--right"></i> -->
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="默认">默认</el-dropdown-item>
                  <el-dropdown-item command="氮">氮</el-dropdown-item>
                  <el-dropdown-item command="磷">磷</el-dropdown-item>
                  <el-dropdown-item command="钾">钾</el-dropdown-item>
                  <el-dropdown-item command="EC">EC值</el-dropdown-item>
                  <el-dropdown-item command="pH">pH</el-dropdown-item>
                  <el-dropdown-item command="温度">温度</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <leftTopVue
            ref="leftTop"
            style="margin-top: -50px; width: 100%"
          ></leftTopVue>
        </div>
      </div>
      <div class="flex justb alit">
        <div class="title" style="margin: 35px 0 20px 0">历史施肥</div>
        <div class="db" @click="getListAssay">对比</div>
      </div>

      <div class="flexCol alit fertiliTable">
        <el-table
          style="background-color: transparent; width: 100%"
          ref="singleTable"
          :data="tableData"
          :row-class-name="rowStyle"
          :header-row-class-name="headerstyle"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column label="地块" align="center">
            <template slot-scope="scope">{{ scope.row.plotName }}</template>
          </el-table-column>
          <el-table-column prop="feedDate" label="施肥时间" align="center">
            <template slot-scope="scope"
              >{{ scope.row.feedDate[0] }}-{{ scope.row.feedDate[1] }}-{{
                scope.row.feedDate[2]
              }}</template
            >
          </el-table-column>
          <el-table-column prop="nitrogen" label="氮" align="center">
          </el-table-column>
          <el-table-column prop="phosphorus" label="磷" align="center">
          </el-table-column>
          <el-table-column prop="potassium" label="钾" align="center">
          </el-table-column>
          <el-table-column prop="situation" label="设备情况" align="center">
          </el-table-column>
          <el-table-column prop="duration" label="执行时间" align="center">
          </el-table-column>
          <el-table-column prop="operator" label="操作人" align="center">
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination-page"
          background
          :current-page="page"
          :page-size="6"
          layout="total, prev, pager, next, jumper"
          :total="total"
          style="margin-top: 10px"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <div class="right">
      <div class="title flex alit">
        测评报告
        <el-popover placement="left" width="800" trigger="hover">
          <img
            src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E4%BD%9C%E7%89%A9%E6%A8%A1%E5%9E%8B/768697b3952096bff3bd3f5022c49268.png"
            style="width: 100%; height: 100%"
            alt=""
          />
          <img class="help" slot="reference" src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E4%BD%9C%E7%89%A9%E6%A8%A1%E5%9E%8B/%E5%B8%AE%E5%8A%A9.png" alt="">
        </el-popover>
      </div>
      <div class="flexCol alit" style="flex: 1">
        <div class="flex justb fx-top" style="">
          <div class="fx-title flex alit justc">
            <img
              class="img1"
              src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%96%BD%E8%82%A5%E5%88%86%E6%9E%90/%E6%96%BD%E8%82%A5%E5%89%8D%402x.png"
              alt=""
            />
            <div class="">施肥前</div>
          </div>
          <div class="fx-title flex alit justc">
            <img
              class="img2"
              src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%96%BD%E8%82%A5%E5%88%86%E6%9E%90/%E6%96%BD%E8%82%A5%E5%90%8E%402x.png"
              alt=""
            />
            <div class="" style="color: #27d320">施肥后</div>
          </div>
          <div class="fx-title flex alit justc">
            <img
              class="img3"
              src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%96%BD%E8%82%A5%E5%88%86%E6%9E%90/%E5%8F%98%E5%8C%96%402x.png"
              alt=""
            />
            <div class="" style="color: #16ffd1">变化</div>
          </div>
        </div>
        <div class="" v-if="listAssay.length > 0">
          <div class="flex alit justb bg-one">
            <div class="flex alit justc fx-width">
              <div class="">叶面健康度</div>
              <div class="">{{ listAssay[0].leaf }}</div>
            </div>
            <div class="flex alit justc fx-width">
              <div class="">叶面健康度</div>
              <div class="">{{ listAssay[1].leaf }}</div>
            </div>
            <div class="fx-width flex alit justc">
              <img
                v-if="listAssay[2].leaf < 0"
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%96%BD%E8%82%A5%E5%88%86%E6%9E%90/%E4%B8%8B%E9%99%8D%402x%20%282%29.png"
                alt=""
              />
              <img
                v-else-if="listAssay[2].leaf > 0"
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%96%BD%E8%82%A5%E5%88%86%E6%9E%90/%E4%B8%8A%E5%8D%87%402x%20%281%29.png"
                alt=""
              />
              <div class="" style="text-align: center" v-else>---</div>
            </div>
          </div>
          <div class="flex justb alit bg-two">
            <div class="flex alit justc fx-width">
              <div class="">茎秆粗细</div>
              <div class="">{{ listAssay[0].stem }}</div>
            </div>
            <div class="flex alit justc fx-width">
              <div class="">茎秆粗细</div>
              <div class="">{{ listAssay[1].stem }}</div>
            </div>
            <div class="fx-width flex alit justc">
              <img
                v-if="listAssay[2].stem < 0"
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%96%BD%E8%82%A5%E5%88%86%E6%9E%90/%E4%B8%8B%E9%99%8D%402x%20%282%29.png"
                alt=""
              />
              <img
                v-else-if="listAssay[2].stem > 0"
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%96%BD%E8%82%A5%E5%88%86%E6%9E%90/%E4%B8%8A%E5%8D%87%402x%20%281%29.png"
                alt=""
              />
              <div class="" style="text-align: center" v-else>---</div>
            </div>
          </div>
          <div class="flex justb alit bg-one">
            <div class="flex alit justc fx-width">
              <div class="">果实发育</div>
              <div class="">{{ listAssay[0].fruit }}</div>
            </div>
            <div class="flex alit justc fx-width">
              <div class="">果实发育</div>
              <div class="">{{ listAssay[1].fruit }}</div>
            </div>
            <div class="fx-width flex alit justc">
              <img
                v-if="listAssay[2].fruit < 0"
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%96%BD%E8%82%A5%E5%88%86%E6%9E%90/%E4%B8%8B%E9%99%8D%402x%20%282%29.png"
                alt=""
              />
              <img
                v-else-if="listAssay[2].fruit > 0"
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%96%BD%E8%82%A5%E5%88%86%E6%9E%90/%E4%B8%8A%E5%8D%87%402x%20%281%29.png"
                alt=""
              />
              <div class="" style="text-align: center" v-else>---</div>
            </div>
          </div>
          <div class="flex justb alit bg-two">
            <div class="flex alit justc fx-width">
              <div class="">土壤氮</div>
              <div class="">{{ listAssay[0].nitrogen }}</div>
            </div>
            <div class="flex alit justc fx-width">
              <div class="">土壤氮</div>
              <div class="">{{ listAssay[1].nitrogen }}</div>
            </div>
            <div class="fx-width flex alit justc">
              <img
                v-if="listAssay[2].nitrogen < 0"
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%96%BD%E8%82%A5%E5%88%86%E6%9E%90/%E4%B8%8B%E9%99%8D%402x%20%282%29.png"
                alt=""
              />
              <img
                v-else-if="listAssay[2].nitrogen > 0"
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%96%BD%E8%82%A5%E5%88%86%E6%9E%90/%E4%B8%8A%E5%8D%87%402x%20%281%29.png"
                alt=""
              />
              <div class="" style="text-align: center" v-else>---</div>
            </div>
          </div>
          <div class="flex justb alit bg-one">
            <div class="flex alit justc fx-width">
              <div class="">土壤磷</div>
              <div class="">{{ listAssay[0].phosphorus }}</div>
            </div>
            <div class="flex alit justc fx-width">
              <div class="">土壤磷</div>
              <div class="">{{ listAssay[1].phosphorus }}</div>
            </div>
            <div class="fx-width flex alit justc">
              <img
                v-if="listAssay[2].phosphorus < 0"
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%96%BD%E8%82%A5%E5%88%86%E6%9E%90/%E4%B8%8B%E9%99%8D%402x%20%282%29.png"
                alt=""
              />
              <img
                v-else-if="listAssay[2].phosphorus > 0"
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%96%BD%E8%82%A5%E5%88%86%E6%9E%90/%E4%B8%8A%E5%8D%87%402x%20%281%29.png"
                alt=""
              />
              <div class="" style="text-align: center" v-else>---</div>
            </div>
          </div>
          <div class="flex justb alit bg-two">
            <div class="flex alit justc fx-width">
              <div class="">土壤钾</div>
              <div class="">{{ listAssay[0].potassium }}</div>
            </div>
            <div class="flex alit justc fx-width">
              <div class="">土壤钾</div>
              <div class="">{{ listAssay[1].potassium }}</div>
            </div>
            <div class="fx-width flex alit justc">
              <img
                v-if="listAssay[2].potassium < 0"
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%96%BD%E8%82%A5%E5%88%86%E6%9E%90/%E4%B8%8B%E9%99%8D%402x%20%282%29.png"
                alt=""
              />
              <img
                v-else-if="listAssay[2].potassium > 0"
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%96%BD%E8%82%A5%E5%88%86%E6%9E%90/%E4%B8%8A%E5%8D%87%402x%20%281%29.png"
                alt=""
              />
              <div class="" style="text-align: center" v-else>---</div>
            </div>
          </div>
          <div class="flex justb alit bg-one">
            <div class="flex alit justc fx-width">
              <div class="">病虫害指数</div>
              <div class="">{{ listAssay[0].evil }}</div>
            </div>
            <div class="flex alit justc fx-width">
              <div class="">病虫害指数</div>
              <div class="">{{ listAssay[1].evil }}</div>
            </div>
            <div class="fx-width flex alit justc">
              <img
                v-if="listAssay[2].evil < 0"
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%96%BD%E8%82%A5%E5%88%86%E6%9E%90/%E4%B8%8B%E9%99%8D%402x%20%282%29.png"
                alt=""
              />
              <img
                v-else-if="listAssay[2].evil > 0"
                src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%96%BD%E8%82%A5%E5%88%86%E6%9E%90/%E4%B8%8A%E5%8D%87%402x%20%281%29.png"
                alt=""
              />
              <div class="" style="text-align: center" v-else>---</div>
            </div>
          </div>
        </div>
      </div>
      <div class="title" style="margin: 30px 0">AI分析</div>
      <div class="ai">
        <div class="">
          <div class="flex alit jl">
            <img
              src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/gif/Ai%E5%9B%BE%E6%A0%87%402x.png"
              alt=""
            />
            结论
          </div>
          <div class="hengxian"></div>
          <div
            class="jl-content"
            v-if="listAssay.length > 0"
            v-html="listAssay[2].analysis"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import leftTopVue from "./leftTop.vue";
import ybp1Vue from "./ybp1.vue";
import ybp2Vue from "./ybp2.vue";
import ybp3Vue from "./ybp3.vue";
export default {
  components: {
    leftTopVue,
    ybp1Vue,
    ybp2Vue,
    ybp3Vue,
  },
  data() {
    return {
      leftTopTableData: [
        {
          title: "计划施肥",
          nitrogen: "12kg",
          phosphorus: "6kg",
          potassium: "15kg",
          startTime: "2026-05-01",
          endTime: "2026-05-15",
        },
        {
          title: "实际施肥",
          nitrogen: "9kg",
          phosphorus: "6kg",
          potassium: "18kg",
          startTime: "2026-05-03",
          endTime: "2026-05-17",
        },
      ],
      page: 1, //页码
      total: 0, //总条数
      tableData: [], //表格数据
      tableSelect: [], //表格选中数据
      listAssay: [], //分析报告详情0为施肥前 1为施肥后 2为指数
      messageList: [
        "关闭水肥搅拌",
        "关闭水肥灌溉泵",
        "关闭水肥施肥泵",
        "设置三通道流量",
        "开启水肥搅拌",
        "开启水肥灌溉泵",
        "开启水肥施肥泵",
      ], //消息数据
    };
  },
  created() {
    this.getHistoryData();
  },
  methods: {
    headerstyle() {
      return "table-header";
    },
    rowStyle({ row, rowIndex }) {
      console.log(rowIndex);
      if (rowIndex % 2 == 0) {
        return "tabletrBg1";
      } else {
        return "tabletrBg2";
      }
    },
    rowTopStyle() {
      return "top-table-bg";
    },
    //下拉菜单点击事件
    dropcommand(e) {
      this.$refs.leftTop.changeEcharts(e);
    },
    getYestodayData() {
      const today = new Date();
      // 获取昨日日期
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      return this.utils.changeTimeNoHms(yesterday);
    },
    getNowData() {
      const today = new Date();
      return this.utils.changeTimeNoHms(today);
    },
    // 获取分析报告
    getListAssay() {
      let da = this.tableSelect[0].plotName;
      if (this.tableSelect.length == 0) {
        this.$message({
          message: "请选择对比数据",
          type: "warning",
        });
        return;
      }
      for (let i = 0; i < this.tableSelect.length; i++) {
        if (this.tableSelect[i].plotName != da) {
          this.$message({
            message: "请选择相同地块进行对比",
            type: "warning",
          });
          return;
        }
      }
      const loading = this.$loading({
        lock: true,
        text: "分析中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      setTimeout(() => {
        this.$request(
          `iot/screen/feed/listAssay?plotName=${this.tableSelect[0].plotName}`
        ).then((res) => {
          loading.close();
          this.listAssay = res.data;
        });
      }, 2000);
    },
    // 页面页数
    handleCurrentChange(e) {
      this.page = e;
      this.getHistoryData();
    },
    //历史施肥数据
    getHistoryData() {
      this.$request(
        `iot/screen/feed/getHistory?pageNo=${this.page}&pageSize=6`
      ).then((res) => {
        if (this.tableData.length == 0) {
          setTimeout(() => {
            this.toggleSelection([this.tableData[0]]);
          }, 200);
          setTimeout(() => {
            this.getListAssay();
          }, 800);
        }
        this.total = res.data.total;
        this.tableData = res.data.list;
      });
    },
    //默认选中1 2行
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.singleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.singleTable.clearSelection();
      }
    },
    //选中框回调
    handleSelectionChange(e) {
      this.tableSelect = e;
    },
  },
};
</script>

<style>
.top-table-bg {
  background: none !important;
}
.table-header {
  background: none !important;
  background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%96%BD%E8%82%A5%E5%88%86%E6%9E%90/%E8%A1%A8%E6%A0%BC%E6%A0%87%E9%A2%98%402x.png") !important;
  background-size: 100% 100% !important;
}
.tabletrBg1 {
  background: rgba(35, 188, 249, 0.2) !important;
}
.tabletrBg2 {
  background: rgba(29, 111, 211, 0.178) !important;
}
.dropcheck .el-button {
  background: #ffffff00 !important;
  border: none !important;
}
.el-carousel__item h3 {
  font-size: 14px;
  opacity: 0.75;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  /* background-color: #ffffff; */
  color: #fff;
}

.el-carousel__item:nth-child(2n + 1) {
  /* background-color: #ffffff; */
  color: #fff;
}
.pagination-page .el-pagination__editor.el-input .el-input__inner {
  border: none !important;
  background: rgba(34, 128, 238, 0.3) !important;
  color: #fff !important;
}
.pagination-page .el-pagination__jump {
  color: #fff !important;
}
.pagination-page .active {
  background: #2280ee !important;
  color: #fff !important;
}
.el-pager li {
  background: rgba(34, 128, 238, 0.3) !important;
  color: #fff !important;
}
.pagination-page .btn-prev {
  background: rgba(34, 128, 238, 0.3) !important;
}
.pagination-page .btn-prev .el-icon {
  color: #fff;
}
.pagination-page .btn-next {
  background: rgba(34, 128, 238, 0.3) !important;
}
.pagination-page .btn-next .el-icon {
  color: #fff;
}
.pagination-page .el-pagination__total {
  color: #fff !important;
}

/* 取消整张表格的悬停效果 */
.fertiliTable .el-table .el-table__body tr:hover > td {
  background-color: initial !important;
}
.fertiliTable .el-table tr {
  /* background: none !important; */
  color: #ffffff;
}
/* .has-gutter {
  background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%96%BD%E8%82%A5%E5%88%86%E6%9E%90/%E8%A1%A8%E6%A0%BC%E6%A0%87%E9%A2%98%402x.png");
  background-size: 100% 100%;
} */
.fertiliTable .el-table th.el-table__cell {
  background: none !important;
  color: #ffffff;
}
.fertiliTable .el-table td.el-table__cell,
.fertiliTable .el-table th.el-table__cell.is-leaf {
  border-bottom: 0px !important;
}
.fertiliTable .el-table::before {
  height: 0 !important;
}
</style>
<style lang="scss" scoped>
.dropcheck {
  position: relative;
  z-index: 99;
}
.title {
  width: 560px;
}
.right {
  width: 700px;
  margin-top: 11vh;
  position: relative;
  z-index: 999;
  .help{
    width: 20px;
    height: 20px;
    margin-left: 10px;
    cursor: pointer;
  }
  .ai {
    width: 660px;
    height: 320px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/gif/Ai%E7%BB%93%E8%AE%BA%E8%83%8C%E6%99%AF%402x.png") !important;
    background-size: 100% 100% !important;
    padding: 18px 0;
    .jl {
      margin: 18px 0 0 50px;
      img {
        width: 30px;
        height: 27px;
        margin-right: 5px;
      }

      font-family: YouSheBiaoTiHei;
      font-size: 22px;
      color: #ffffff;
      letter-spacing: 1px;
    }
    .hengxian {
      width: 104px;
      height: 6px;
      background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/gif/%E7%BB%93%E8%AE%BA%E6%A1%86%E7%BA%BF%402x.png") !important;
      background-size: 100% 100% !important;
      margin-left: 50px;
      margin-top: 5px;
    }
    .jl-content {
      width: 580px;
      margin-left: 50px;
      margin-top: 10px;
      font-family: AlimamaShuHeiTi, AlimamaShuHeiTi;
      font-size: 16px;
      color: #ffffff;
      line-height: 23px;
      letter-spacing: 1px;
      text-indent: 4ch;
    }
  }
  .fx-width {
    width: 33%;
    div:first-child {
      width: 90px;
    }
  }
  .bg-one {
    width: 670px;
    height: 43px;
    background: rgba(35, 188, 249, 0.2);
    color: #ffffff;

    font-weight: 400;
    font-size: 14px;

    img {
      width: 16px;
      height: 16px;
    }
  }
  .bg-two {
    width: 670px;
    height: 43px;
    background: rgba(29, 111, 211, 0.178);
    color: #ffffff;
    font-weight: 400;
    font-size: 14px;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;

    img {
      width: 16px;
      height: 16px;
    }
  }
  .fx-top {
    margin: 10px 0 10px 0;
    width: 630px;
  }
  .fx-title {
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%96%BD%E8%82%A5%E5%88%86%E6%9E%90/%E5%88%86%E6%9E%90%E6%A0%87%E9%A2%98%E8%83%8C%E6%99%AF%402x.png");
    background-size: 100% 100%;
    width: 190px;
    height: 48px;
    font-weight: 400;
    font-size: 18px;
    color: #f28c1b;
    .img1 {
      width: 24px;
      height: 26px;
      margin-right: 10px;
    }
    .img2 {
      width: 22px;
      height: 26px;
      margin-right: 10px;
    }
    .img3 {
      width: 23px;
      height: 26px;
      margin-right: 10px;
    }
  }
}
.lfet {
  width: 1060px;
  margin-top: 11vh;
  position: relative;
  z-index: 999;
  margin: 10vh 50px 0 30px;
  .check-button {
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/gif/%E9%80%89%E6%8B%A9%402x.png") !important;
    background-size: 100% 100% !important;
    background-repeat: no-repeat !important;
    background-position-x: 4px !important;
    background-position-y: 2px !important;
    color: #ffffff !important;
    width: 103px;
    height: 44px;
  }
  .medium {
    margin-left: 10px;
  }
  .db {
    width: 100px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    cursor: pointer;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/gif/%E5%AF%B9%E6%AF%94%402x.png");
    background-size: 100% 100%;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #ffffff;
  }
  .table-header {
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%96%BD%E8%82%A5%E5%88%86%E6%9E%90/%E8%A1%A8%E6%A0%BC%E6%A0%87%E9%A2%98%402x.png") !important;
    background-size: 100% 100% !important;
    color: #000;
  }
  .czlog {
    font-weight: 400;
    font-size: 12px;
    color: #d9eaff;
    width: 451px;
    height: 31px;
    background: linear-gradient(90deg, #061d34 0%, #0c437b88 100%);
    img {
      width: 25px;
      height: 24px;
      margin: 0 19px 0 9px;
    }
  }
  .eps {
    width: 450px;
    margin: 30px 0;
    img {
      width: 49px;
      height: 56px;
      margin-right: 16px;
    }
    .text3 {
      width: 71px;
      height: 20px;
      background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%96%BD%E8%82%A5%E5%88%86%E6%9E%90/%E5%80%BC%E6%A0%87%E9%A2%98%E8%83%8C%E6%99%AF%402x.png");
      background-size: 100% 11px;
      background-position-y: 7px;
      font-weight: 300;
      font-size: 12px;
      color: #ffffff;
      background-repeat: no-repeat;
      margin-bottom: 4px;
      padding-left: 8px;
    }
    .text4 {
      width: 76px;
      height: 24px;
      background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%96%BD%E8%82%A5%E5%88%86%E6%9E%90/%E5%80%BC%E6%95%B0%E5%AD%97%E8%83%8C%E6%99%AF%402x.png");
      background-size: 100% 100%;
      padding-left: 8px;
      font-family: YouSheBiaoTiHei;
      font-size: 23px;
      color: #d9eaff;
    }
  }
  .ybp {
    width: 440px;
    font-weight: 300;
    font-size: 12px;
    color: #ffffff;
    .ybpecharts {
      width: 120px !important;
      height: 108px !important;
    }
  }
  .dlj {
    width: 450px;
    margin: 28px 0 14px 0;
    .bili {
      color: #fff;
      font-size: 30px;
      margin-top: -15px;
    }
    img {
      width: 63px;
      height: 63px;
      margin-right: 10px;
    }
    .text1 {
      font-weight: 300;
      font-size: 14px;
      color: #ffffff;
    }
    .text2 {
      font-family: YouSheBiaoTiHei;
      font-size: 21px;
      color: #d9eaff;
    }
  }
}
.page {
  width: 100vw;
  height: 100vh;
  background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E5%9B%9B%E6%83%85%E8%83%8C%E6%99%AF%402x.png");
  background-size: 100% 100%;
  overflow: hidden;
}
</style>